import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import Sidebar from './components/Sidebar';
import TopNav from './components/TopNav';
import PostModal from './components/PostModal';
import Dashboard from './pages/Dashboard';
import Pipeline from './pages/Pipeline';
import Performance from './pages/Performance';
import Audience from './pages/Audience';
import Calendar from './pages/Calendar';
import Settings from './pages/Settings';
import Login from './pages/Login';
import LoadingSpinner from './components/LoadingSpinner';

// Protected Route component
const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return <LoadingSpinner />;
  }

  return isAuthenticated ? children : <Navigate to="/login" />;
};

// Main App Layout component
const AppLayout = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [showGlobalPostModal, setShowGlobalPostModal] = useState(false);

  return (
    <div className="flex h-screen bg-surface">
      <Sidebar sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />

      <div className="flex-1 flex flex-col overflow-hidden">
        <TopNav setSidebarOpen={setSidebarOpen} onCreatePost={() => setShowGlobalPostModal(true)} />

        <main className="flex-1 overflow-x-hidden overflow-y-auto bg-surface p-6">
          <Routes>
            <Route path="/" element={<Dashboard />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/pipeline" element={<Pipeline />} />
            <Route path="/performance" element={<Performance />} />
            <Route path="/audience" element={<Audience />} />
            <Route path="/calendar" element={<Calendar />} />
            <Route path="/settings" element={<Settings />} />
          </Routes>
        </main>
      </div>

      <PostModal
        isOpen={showGlobalPostModal}
        onClose={() => setShowGlobalPostModal(false)}
        onSuccess={() => setShowGlobalPostModal(false)}
      />
    </div>
  );
};

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/*" element={
            <ProtectedRoute>
              <AppLayout />
            </ProtectedRoute>
          } />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
